import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import LanguageSwitcher from './LanguageSwitcher';

// Windows-Start-menu-style translucent flyout that pops up above the Dock.
//
// ANCORAGGIO (2026-09-06). Lo stesso menu si apre da due punti: la dock in
// basso e il pulsante dell'account in alto a destra. Aperto dalla dock
// compare sopra la dock, che e' giusto. Aperto dal pulsante in alto
// compariva ugualmente in fondo allo schermo, lontanissimo dal dito che
// l'aveva toccato: si tocca in alto e succede qualcosa in basso, che e' il
// modo piu' rapido di far credere che il sito abbia sbagliato. Quando arriva
// `ancoraRef` il menu si posiziona sotto quel pulsante, misurandone la
// posizione vera invece di indovinarla con un margine fisso — cosi' resta
// allineato anche quando accanto c'e' il pulsante di amministrazione, e su
// telefono dove il pulsante e' solo un'icona.
export default function DockMenu({ open, onClose, user, planLabel, planEmoji, planColor, items, ancoraRef }) {
  const ref = useRef(null);
  const [posizione, setPosizione] = useState(null);

  useEffect(() => {
    if (!open) return;
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  // useLayoutEffect e non useEffect: la posizione dev'essere gia' giusta al
  // primo disegno, altrimenti il menu appare per un fotogramma in fondo e
  // poi salta in alto.
  useLayoutEffect(() => {
    const bottone = ancoraRef?.current;
    if (!open || !bottone) { setPosizione(null); return undefined; }
    const calcola = () => {
      const r = bottone.getBoundingClientRect();
      // Ancorato a DESTRA del pulsante: cosi' un menu piu' largo del
      // pulsante cresce verso l'interno della pagina e non esce dallo
      // schermo. L'intestazione e' sticky in cima, quindi non serve
      // ricalcolare allo scorrimento: resta dov'e'.
      setPosizione({ top: Math.round(r.bottom + 8), right: Math.round(window.innerWidth - r.right) });
    };
    calcola();
    window.addEventListener('resize', calcola);
    return () => window.removeEventListener('resize', calcola);
  }, [open, ancoraRef]);

  if (!open) return null;

  const initial = (user?.username || '?').charAt(0).toUpperCase();

  return (
    <>
      <div className="dockmenu-backdrop" onClick={onClose} />
      <div
        className={`dockmenu${posizione ? ' dockmenu-ancorata' : ''}`}
        ref={ref}
        style={posizione
          ? { '--pc': planColor, top: `${posizione.top}px`, right: `${posizione.right}px` }
          : { '--pc': planColor }}
      >
        <div className="dockmenu-header">
          <div className="dockmenu-avatar">{initial}</div>
          <div className="dockmenu-who">
            <span className="dockmenu-username">@{user?.username}</span>
            <span className="dockmenu-plan">{planEmoji} {planLabel}</span>
          </div>
          <LanguageSwitcher />
        </div>
        <div className="dockmenu-sep" />
        <div className="dockmenu-items">
          {items.map((item, i) => (
            item.type === 'segmented' ? (
              // A live setting (e.g. list/grid view), not a navigation action —
              // switching it shouldn't close the flyout the way every other
              // item here does, so this doesn't call onClose().
              <div key={i} className="dockmenu-item dockmenu-item-segmented">
                <div className="dockmenu-segmented-label-row">
                  <span className="dockmenu-item-icon">{item.icon}</span>
                  <span>{item.label}</span>
                </div>
                <div className="dockmenu-segmented">
                  {item.options.map(opt => (
                    <button
                      key={opt.value}
                      className={opt.value === item.value ? 'active' : ''}
                      onClick={() => item.onChange(opt.value)}
                    >
                      {opt.icon} {opt.label}
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              <button
                key={i}
                className={`dockmenu-item ${item.danger ? 'dockmenu-item-danger' : ''}`}
                onClick={() => { item.action(); onClose(); }}
              >
                <span className="dockmenu-item-icon">{item.icon}</span>
                <span>{item.label}</span>
              </button>
            )
          ))}
        </div>
      </div>
    </>
  );
}
